export default function SubmissionStatus() {
  return (
    <div>
      <h1>SubmissionStatus</h1>
    </div>
  );
}
